
<div>
  <!-- Settings Dialog -->
  <cvt-dialog
    :show="visible"
    size="sm"
    :height-auto="true"
    :show-close="closeBtnBoolean"
    @close="handleClose"
  >
    <template #title>
      <h5>{{ $t('element.property.page.settings.label') }}</h5>
    </template>
    <div class="page-manager-dialog">
      <form @submit.prevent="save">
        <div class="form-group">
          <label for="page-name">{{ $t("pagemanager.label.page.name") }}</label>
          <cvt-input
            type="text"
            :value="page.pageName"
            @input="(e) => updatePageSetting('pageName', e)"
          />
          <label for="page-name">{{ $t("pagemanager.label.slug.text") }}</label>
          <cvt-input
            type="text"
            :placeholder="$t('pagemanager.input.text.pagename')"
            :disabled="page.isIndex"
            :value="page.name"
            @input="(e) => updatePageSetting('name', e)"
          />
          {{ $t("pagemanager.label.slug.text") }}
          <strong class="text-muted">
            <span class="help">/</span>
            <span
              class="help"
              v-text="pageSlug"
            />
          </strong>
          <cvt-alert
            v-if="OrgName !== orgNameFreshWork"
            class="w-100"
            color="info"
            icon="exclamation-triangle"
          >
            {{ $t('pagemanager.slug.help.message') }}
          </cvt-alert>
        </div>

        <div class="form-group">
          <label for="page-name">{{ $t("pagemanager.input.placeholder.pagename") }}</label>
          <cvt-input
            type="textarea"
            :placeholder="$t('pagemanager.label.seo')"
            :value="page.description"
            @input="(e) => updatePageSetting('description', e)"
          />
        </div>
        <div class="form-group">
          <input
            v-if="changeToggleToCheckBox"
            id="allowRobotsOnThisPageId"
            v-model="allowRobotsOnThisPage"
            type="checkbox"
          >
          <label for="page-meta">{{ $t("pagemanager.textarea.placeholder.description") }}</label>
          <cvt-switch
            v-if="!changeToggleToCheckBox"
            size="sm"
            color="active"
            type="circular"
            description-type="default"
            :initial-state="allowRobotsOnThisPage"
            :mode="mode"
            @switchToggle="() => onSwitchToggle('allowRobotsOnThisPage')"
          />
        </div>
      </form>
    </div>
    <template #modalFooter>
      <cvt-button
        color="light"
        :loading="saving"
        :outlined="true"
        :text="$t('element.property.cta.cancel')"
        @click="handleClose"
      />
      <cvt-button
        :loading="saving"
        :text="$t('element.property.cta.save')"
        :special-style="saveBtnStyle"
        @click="saveAndClose"
      />
    </template>
  </cvt-dialog>

  <!-- Delete Page Dialog -->
  <cvt-dialog
    :show="deleteVisible"
    :height-auto="true"
    size="sm"
    @close="abortPageRemoval"
  >
    <template #title>
      <h5>{{ $t("pagemanager.cvt_dialog.template.h5") }}</h5>
    </template>
    <cvt-alert
      class="w-100"
      color="warning"
      icon="exclamation-triangle"
    >
      <p>{{ $t("pagemanager.cvt_dialog.cvt_alert.p") }}</p>
    </cvt-alert>
    <template #modalFooter>
      <div class="d-flex">
        <cvt-button
          :loading="removing"
          class="mr-1"
          color="light"
          :text="$t(`pagemanager.cvt_dialog.submit.btn`)"
          @click="proceedPageRemoval"
        />
        <cvt-button
          :loading="removing"
          color="warning"
          :special-style="saveBtnStyle"
          :text="$t(`pagemanager.cvt_dialog.cancel.btn`)"
          @click="abortPageRemoval"
        />
      </div>
    </template>
  </cvt-dialog>

</div>
